import { render } from "./ProejctsOverview.vue?vue&type=template&id=03294616"
import script from "./ProejctsOverview.vue?vue&type=script&lang=js"
export * from "./ProejctsOverview.vue?vue&type=script&lang=js"
script.render = render

export default script